'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$StoreTwoFactorAuthRequest(id, name, kind, payload) {
  this.xP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Ni = null;
  this.Nh = null;
  this.xQ = null;
  this.xP = id;
  this.Ni = name;
  this.Nh = kind;
  this.xQ = payload;
}
export { $c_Lpresto_types$proto$StoreTwoFactorAuthRequest as $c_Lpresto_types$proto$StoreTwoFactorAuthRequest };
$p = $c_Lpresto_types$proto$StoreTwoFactorAuthRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$StoreTwoFactorAuthRequest;
/** @constructor */
function $h_Lpresto_types$proto$StoreTwoFactorAuthRequest() {
}
export { $h_Lpresto_types$proto$StoreTwoFactorAuthRequest as $h_Lpresto_types$proto$StoreTwoFactorAuthRequest };
$h_Lpresto_types$proto$StoreTwoFactorAuthRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("StoreTwoFactorAuthRequest"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.xP;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Ni));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Nh));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xQ));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 4);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$StoreTwoFactorAuthRequest)) {
    var this$1 = this.xP;
    var b = x$0.xP;
    if ((((this$1.e === b.e) && (this$1.f === b.f)) && (this.Ni === x$0.Ni))) {
      var x = this.Nh;
      var x$2 = x$0.Nh;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.xQ;
      var x$4 = x$0.xQ;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 4;
});
$p.s = (function() {
  return "StoreTwoFactorAuthRequest";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.xP;
      break;
    }
    case 1: {
      return this.Ni;
      break;
    }
    case 2: {
      return this.Nh;
      break;
    }
    case 3: {
      return this.xQ;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$StoreTwoFactorAuthRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m5)));
}
export { $isArrayOf_Lpresto_types$proto$StoreTwoFactorAuthRequest as $isArrayOf_Lpresto_types$proto$StoreTwoFactorAuthRequest };
var $d_Lpresto_types$proto$StoreTwoFactorAuthRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$StoreTwoFactorAuthRequest, "presto.types$proto$StoreTwoFactorAuthRequest", ({
  m5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$StoreTwoFactorAuthRequest as $d_Lpresto_types$proto$StoreTwoFactorAuthRequest };
//# sourceMappingURL=presto.types$proto$-Store-Two-Factor-Auth-Request.js.map
